import { Action } from '@ngrx/store';
import { SiteSettingInterface } from 'app/site-settings/models/site-setting.model';
import { ActiveInterface, SSOStatusInterface } from 'app/site-settings/models/active.model';
import { MessageBannerInterface, MessageInterface, MessageTextInterface } from 'app/site-settings/models/message-banner.model';
import { ErrorSSOSingleInterface, ErrorsSSOInterface } from 'app/site-settings/models/error-message';

import { SiteSettingActionType } from './site-setings-action-type.enum';
import { SSOMetadataInterface } from 'app/site-settings/models/sso-metadata.model';

export class LoadSiteSettings implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteSettings;

  public readonly payload: any = undefined;
}

export class LoadSiteSettingsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteSettingsCompleted;

  constructor(public readonly payload: SiteSettingInterface[]) { }
}

export class LoadSiteSettingsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteSettingsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadUserProps implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadUserProps;

  public readonly payload: any = undefined;
}

export class LoadUserPropsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadUserPropsCompleted;

  constructor(public readonly payload: SSOStatusInterface) { }
}

export class LoadUserPropsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadUserPropsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadSSOMetadata implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSSOMetadata;

  public readonly payload: any = undefined;
}

export class LoadSSOMetadataCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSSOMetadataCompleted;

  constructor(public readonly payload: SSOMetadataInterface) { }
}

export class LoadSSOMetadataFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSSOMetadataFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateSiteSetting implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteSetting;

  constructor(public readonly payload: SiteSettingInterface) { }
}

export class UpdateSiteSettingCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteSettingCompleted;

  constructor(public readonly payload: SiteSettingInterface) { }
}

export class UpdateSiteSettingFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteSettingFailed;

  constructor(public readonly payload: string) { }
}


export class LoadBanner implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadMessage;

  constructor(public readonly payload: any = undefined) { }
}

export class LoadBannerCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadMessageCompleted;

  constructor(public readonly payload: MessageBannerInterface) { }
}

export class LoadBannerFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadMessageFailed;

  constructor(public readonly payload: string) { }
}

export class LoadTextBanner implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadTextMessage;

  constructor(public readonly payload: any = undefined) { }
}

export class LoadTextBannerCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadTextMessageCompleted;

  constructor(public readonly payload: MessageTextInterface) { }
}

export class LoadTextBannerFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadTextMessageFailed;

  constructor(public readonly payload: string) { }
}

export class LoadErrorSSOMessage implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadErrorSSOMessage;

  constructor(public readonly payload: any = undefined) { }
}

export class LoadErrorSSOMessageCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadErrorSSOMessageCompleted;

  constructor(public readonly payload: ErrorsSSOInterface[]) { }
}

export class LoadErrorSSOMessageFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadErrorSSOMessageFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateErrorSSOMessage implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateErrorSSOMessage;

  constructor(public readonly payload: any = undefined) { }
}

export class UpdateErrorSSOMessageCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateErrorSSOMessageCompleted;

  constructor(public readonly payload: ErrorSSOSingleInterface) { }
}

export class UpdateErrorSSOMessageFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateErrorSSOMessageFailed;

  constructor(public readonly payload: string) { }
}


export class LoadErrorSSOSingleMessage implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadErrorSSOSingleMessage;

  constructor(public readonly payload: any) { }
}
export class LoadErrorSSOSingleMessageCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadErrorSSOSingleMessageCompleted;

  constructor(public readonly payload: any) { }
}
export class LoadErrorSSOSingleMessageFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadErrorSSOSingleMessageFailed;

  constructor(public readonly payload: string) { }
}

export class CheckSsoKey implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.CheckSsoKey;

  constructor(public readonly payload: string) { }
}

export class CheckSsoKeyCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.CheckSsoKeyCompleted;

  constructor(public readonly payload: any = undefined) { }
}

export class CheckSsoKeyFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.CheckSsoKeyFailed;

  constructor(public readonly payload: string) { }
}


export class UpdateSsoKey implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSsoKey;

  constructor(public readonly payload: string) { }
}

export class UpdateSsoKeyCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSsoKeyCompleted;

  constructor(public readonly payload: any = undefined) { }
}

export class UpdateSsoKeyFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSsoKeyFailed;

  constructor(public readonly payload: string) { }
}


export class UpdateSsoSetting implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSsoSetting;

  constructor(public readonly payload: any) { }
}

export class UpdateSsoSettingCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSsoSettingCompleted;

  constructor(public readonly payload: any = undefined) { }
}

export class UpdateSsoSettingFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSsoSettingFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateBannerCheck implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBannerCheck;

  constructor(public readonly payload: boolean) { }
}

export class UpdateBannerCheckCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBannerCheckCompleted;

  constructor(public readonly payload: any = undefined) { }
}

export class UpdateBannerCheckFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBannerCheckFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateBannerMessage implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBannerMessage;

  constructor(public readonly payload: MessageInterface) { }
}

export class UpdateBannerMessageCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBannerMessageCompleted;

  constructor(public readonly payload: MessageInterface) { }
}

export class UpdateBannerMessageFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBannerMessageFailed;

  constructor(public readonly payload: string) { }
}
